<template>
  <router-view />
</template>

<script>
export default {
  name: 'Lives'
}
</script>
